import { Button } from '@mantine/core';
import React, { ReactNode } from 'react';
import { useObserverReturningStore } from '../../../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../../../concepts/resources/Icon';
import { Flexer } from '../../../dashboard/elements/LayoutElements';
import { useJiraIssueRecord } from './JiraIssueSidebarHooks';

export const JiraIssueSidebarActions = React.memo(({ jiraIssueId, children }: { jiraIssueId: string, children?: ReactNode }) => {
    const record = useObserverReturningStore(useJiraIssueRecord(jiraIssueId));
    return <Flexer flex="row" align="center" justify="space-between" gap="1" padding=".5">
        <Flexer>
            <a href={record.get('url')} target="_blank" rel="noreferrer">
                <Button variant="outline" leftSection={<Icon src="deqo://icons/hero/external-link" size="1.25" />}>
                    Open in Jira
                </Button>
            </a>
        </Flexer>
        <Flexer flex="row" gap="1">
            {children}
        </Flexer>
    </Flexer>;
});
